module.exports = __webpack_public_path__ + "static/media/audio.bdf7861b.png";